import { Component, inject } from '@angular/core';
import { ButtonDirective } from '@lp/directives/button';
import { TranslatePipe } from '@ngx-translate/core';
import { AriaEventDirective } from '@lp/directives/aria';
import { AuthService } from '@lp/services/auth';
import { TypewriterComponent } from '@lp/components/typewriter';
import { SupportMailComponent } from '@lp/components/support-mail';

@Component({
  selector: 'lp-welcome',
  templateUrl: 'welcome.component.html',
  styleUrl: 'welcome.component.scss',
  imports: [ButtonDirective, TranslatePipe, AriaEventDirective, TypewriterComponent, SupportMailComponent]
})
export class WelcomeComponent {
  private _auth = inject(AuthService);

  public loggedIn = this._auth.loggedIn;

  public login(): void {
    this._auth.login();
  }
}
